/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonGridRepositoryResponsePaginatedResponse } from "../types/PersonGridRepositoryResponsePaginatedResponse.ts";
import { personGridRepositoryResponseSchema } from "./personGridRepositoryResponseSchema.ts";

export const personGridRepositoryResponsePaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => personGridRepositoryResponseSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<PersonGridRepositoryResponsePaginatedResponse>;
